import React from 'react'
import { useUserWorkspace } from 'app/components/user-workspace/useUserWorkspace'
import { UserWorkspaceComponent } from 'app/components/user-workspace/UserWorkspaceComponent'

export const handle = {
  title: `Workspace`,
}

export default function UserWorkspace(): React.ReactElement {
  const hookData = useUserWorkspace()
  return <UserWorkspaceComponent {...hookData} />
}
